import { Injectable } from '@angular/core';
import { Notify } from 'notiflix/build/notiflix-notify-aio';
import { OutsideZone } from './zone/zone.decorators';

type ToastMessage = {
    header: string;
    message?: string;
    duration?: number;
    id?: string;
    position?: 'right-top' | 'right-bottom' | 'left-top' | 'left-bottom' | 'center-top' | 'center-bottom' | 'center-center';
    width?: string;
};

@Injectable({
    providedIn: 'root'
})
export class ToastService {

    public async info(info: ToastMessage) {
        return this.showToast(info, 'info');
    }

    public async warning(warning: ToastMessage) {
        return this.showToast(warning, 'warning');
    }

    public async success(success: ToastMessage) {
        return this.showToast(success, 'success');
    }

    public async danger(danger: ToastMessage) {
        return this.showToast(danger, 'danger');
    }

    @OutsideZone()
    private async showToast(data: ToastMessage, type: 'info' | 'warning' | 'success' | 'danger') {
        const color = type === 'info' ? 'info' : type === 'danger' ? 'failure' : type;
        const msg = `<h1 class="!tw-font-semibold !tw-text-xl !tw-mb-2">${data.header}</h1>`
            + (data.message ? `<p class="!tw-text-base !tw-mb-2">${data.message}</p>` : '');

        Notify[color](msg, {
            plainText: false,
            timeout: data.duration ?? 6500,
            ID: data.id,
            position: data.position ?? 'center-bottom',
            clickToClose: true,
            width: data?.width ?? '280px',
            pauseOnHover: true,
            messageMaxLength: 4096
        });
    }

}